import React from 'react';
import ContractorList from "../components/ContractorList";



const ContactPage = () => {
    return (
        <React.Fragment >
            <ContractorList />
        </React.Fragment>
    );
};

export default ContactPage;